import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKENDORDERURL;

const http = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Add token automatically if logged in
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default http;
